import {AGEYTOMESH_TAG_ID} from "../../shared/constants/misc";
import {LimitedLink, StatusPseudoTag} from "../../shared/pages/project/project";
import {CreateLinkTo} from "../../shared/constants/linkTo";
import {BTag} from "../../core/components";
import {bTag} from "../../core";
import {FC, useRef, useState} from "react";
import { COMPETITION_STATUSES, getCompetitionStatus } from "_competition/helpers/getCompetitionStatus";
import { useTranslation } from "react-i18next";
import { Tag } from "@brg/api";
import {BTagsGridNew} from "../../core/components/bTag/bTagsGridNew/bTagsGridNew";

export const CompetitionTagLine: FC<{competitionProps: any, currentTagId?: string }> = ({competitionProps, currentTagId }) => {
    const listRef = useRef<HTMLDivElement>(null);
    const [_, setScrollLeft] = useState(0);
    const competitionStatus = getCompetitionStatus(competitionProps);
    const { t } = useTranslation() 

    const getTagRoute = (v: Tag) => {
        return CreateLinkTo.tag(v.tagId) 
    }

    return <div style={{position: 'relative'}}>
        <BTagsGridNew scrollMode="all" ref={listRef} onScroll={e => setScrollLeft(listRef?.current?.scrollLeft || 0)}>
            {
                competitionStatus === COMPETITION_STATUSES.full_finish || competitionStatus === COMPETITION_STATUSES.apply_finish ?
                    <StatusPseudoTag
                    onClick={(e:any) => {
                        e.preventDefault()
                        e.stopPropagation()
                    }
                    }
                    >
                        {
                            t(competitionStatus === COMPETITION_STATUSES.full_finish ?
                            'competition.statuses.Competition_ended'
                            :
                            'competition.statuses.Competition_apply_ended')
                        }
                    </StatusPseudoTag>
                    :
                    undefined
            }
            {[ ...competitionProps.requredTags, ...competitionProps.regularTags ].map((v) => {
                const target = (v.tagId === AGEYTOMESH_TAG_ID || v.isTeamTag) ? '_blank' : '';
                return (
                    <LimitedLink style={{...(currentTagId && v.tagId === currentTagId && { pointerEvents: 'none'})}} key={v.tagId} to={getTagRoute(v)} target={target}>
                        <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag isCompetitionsTitleTag isCompetitionsStyleTag>
                            {bTag.title(v)}
                        </BTag>
                    </LimitedLink>
                )
            })}
        </BTagsGridNew>
    </div>
}import {AGEYTOMESH_TAG_ID} from "../../shared/constants/misc";
import {LimitedLink, StatusPseudoTag} from "../../shared/pages/project/project";
import {CreateLinkTo} from "../../shared/constants/linkTo";
import {BTag} from "../../core/components";
import {bTag} from "../../core";
import {FC, useRef, useState} from "react";
import { COMPETITION_STATUSES, getCompetitionStatus } from "_competition/helpers/getCompetitionStatus";
import { useTranslation } from "react-i18next";
import { Tag } from "@brg/api";
import {BTagsGridNew} from "../../core/components/bTag/bTagsGridNew/bTagsGridNew";

export const CompetitionTagLine: FC<{competitionProps: any, currentTagId?: string }> = ({competitionProps, currentTagId }) => {
    const listRef = useRef<HTMLDivElement>(null);
    const [_, setScrollLeft] = useState(0);
    const competitionStatus = getCompetitionStatus(competitionProps);
    const { t } = useTranslation() 

    const getTagRoute = (v: Tag) => {
        return CreateLinkTo.tag(v.tagId) 
    }

    return <div style={{position: 'relative'}}>
        <BTagsGridNew scrollMode="all" ref={listRef} onScroll={e => setScrollLeft(listRef?.current?.scrollLeft || 0)}>
            {
                competitionStatus === COMPETITION_STATUSES.full_finish || competitionStatus === COMPETITION_STATUSES.apply_finish ?
                    <StatusPseudoTag
                    onClick={(e:any) => {
                        e.preventDefault()
                        e.stopPropagation()
                    }
                    }
                    >
                        {
                            t(competitionStatus === COMPETITION_STATUSES.full_finish ?
                            'competition.statuses.Competition_ended'
                            :
                            'competition.statuses.Competition_apply_ended')
                        }
                    </StatusPseudoTag>
                    :
                    undefined
            }
            {[ ...competitionProps.requredTags, ...competitionProps.regularTags ].map((v) => {
                const target = (v.tagId === AGEYTOMESH_TAG_ID || v.isTeamTag) ? '_blank' : '';
                return (
                    <LimitedLink style={{...(currentTagId && v.tagId === currentTagId && { pointerEvents: 'none'})}} key={v.tagId} to={getTagRoute(v)} target={target}>
                        <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag isCompetitionsTitleTag isCompetitionsStyleTag>
                            {bTag.title(v)}
                        </BTag>
                    </LimitedLink>
                )
            })}
        </BTagsGridNew>
    </div>
}